export default class KliraSubscription {
    has_night_cream = false;
    has_body = false;
    has_day_script = false;
    has_ended_day_script = false;
    has_ended_night_cream = false
    has_ended_body = false;
    items = [];
}